import * as THREE from 'three';

export const DESIGN_SCHEME_SURFACE_KIND_KEY = 'designSchemeSurfaceKind';

export type DesignSchemeSurfaceKind = 'opaque' | 'glazed' | 'pv' | 'other';

export function tagDesignSchemeSurfaceMaterial(
    material: THREE.Material | THREE.Material[] | undefined,
    kind: DesignSchemeSurfaceKind
): void {
    if (!material) return;

    const materials = Array.isArray(material) ? material : [material];
    materials.forEach((entry) => {
        entry.userData[DESIGN_SCHEME_SURFACE_KIND_KEY] = kind;
    });
}

export function getDesignSchemeSurfaceKind(material: THREE.Material | undefined): DesignSchemeSurfaceKind {
    if (!material) return 'other';

    const taggedKind = material.userData?.[DESIGN_SCHEME_SURFACE_KIND_KEY];
    if (taggedKind === 'opaque' || taggedKind === 'glazed' || taggedKind === 'pv' || taggedKind === 'other') {
        return taggedKind;
    }

    return 'other';
}
